/** AI yordamchi API (`/api/v1/assistant/`). */
import { apiRequest } from "@/shared/api/client";

export interface ToolCall {
  id: string;
  type: "function";
  function: { name: string; arguments: string };
}

/** OpenAI-mos suhbat xabari — tarixni brauzer saqlaydi, server har safar tekshiradi. */
export type ChatMessage =
  | { role: "user"; content: string }
  | { role: "assistant"; content: string; tool_calls?: ToolCall[] }
  | { role: "tool"; tool_call_id: string; content: string };

export interface PageContext {
  url: string;
  /** `pageAgent.snapshot()` natijasi: id bilan raqamlangan interaktiv elementlar. */
  elements: string;
  /** Foydalanuvchiga ochiq sahifalar — `navigate` faqat shulardan foydalanadi. */
  pages: Array<{ path: string; label: string }>;
}

export interface UiAction {
  id: string;
  name: "click" | "type_text" | "select_option" | "navigate" | "scroll";
  args: Record<string, unknown>;
}

export interface ChatTurn {
  type: "reply" | "actions";
  reply: string;
  actions?: UiAction[];
  /** Tarixga qo'shiladigan xabarlar (model javobi va ma'lumot asboblari natijalari). */
  append: ChatMessage[];
}

export const assistantApi = {
  chat: (messages: ChatMessage[], page: PageContext, signal?: AbortSignal, isPublic = false) =>
    apiRequest<ChatTurn>(isPublic ? "/assistant/public/chat/" : "/assistant/chat/", {
      method: "POST",
      body: { messages, page },
      signal,
    }),
};
